var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppBehance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.26 0H9.74C4.36075 0 0 4.36075 0 9.74V44.26C0 49.6393 4.36075 54 9.74 54H44.26C49.6393 54 54 49.6393 54 44.26V9.74C54 4.36075 49.6393 0 44.26 0Z",
    fill: "#000B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83008 14.4208H18.5201C24.3701 14.4208 27.2501 17.4208 27.2501 20.9708C27.2501 23.3808 26.4401 25.1108 24.4401 26.1908C26.6601 27.1208 28.0701 28.7808 28.1001 31.5608C28.1401 36.0408 24.5101 39.2208 17.6601 39.2208H6.83008V14.4208ZM17.7401 24.1508C19.3701 24.1508 20.3701 23.4508 20.3701 22.0008C20.3701 20.6708 19.5201 19.8908 17.6701 19.8908H13.6701V24.1508H17.7401ZM17.8601 33.7408C19.6401 33.7408 21.0101 33.0708 21.0101 31.3708C21.0101 30.0008 20.2001 29.0808 18.0901 29.0808H13.6901V33.7408H17.8701H17.8601Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5201 29.0008C48.5201 29.8908 48.4501 30.8508 48.3301 31.5908H36.2301C36.9701 33.4408 38.7501 34.3308 41.5201 34.3308C43.5201 34.3308 45.2601 33.9608 47.0001 33.1508L47.0701 38.2908C45.1801 39.2508 43.1501 39.5908 40.5201 39.5908C34.0401 39.5908 29.7201 36.0008 29.7201 29.4908C29.7201 23.5308 33.8601 19.5708 39.3401 19.5708C44.8201 19.5708 48.5201 23.2008 48.5201 29.0108V29.0008ZM44.8601 14.0508V18.3408H33.9801V14.0508H44.8601ZM36.0101 27.3708H42.4901C42.3401 25.6308 41.2701 24.4108 39.3801 24.4108C37.4901 24.4108 36.4201 25.3708 36.0101 27.3708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppBehance);
export default __webpack_public_path__ + "static/media/B_app_Behance.fe290166513ee5d198f98d25269cafc6.svg";
export { ForwardRef as ReactComponent };